import { logger } from '@lusha/client-logger';
import { flow, getRoot } from 'mobx-state-tree';
import { fetchUserCompanyInfo } from '../../../API/userAPI';
const Actions = self => ({
    loadInfo: flow(function* loadCompanyInfo() {
        var _a, _b;
        const { user } = getRoot(self);
        if (!self.isLoaded) {
            logger.info(`Fetching ${user.email} company's data`);
            try {
                const response = yield fetchUserCompanyInfo();
                self.isLoaded = true;
                self.minSize = (_a = response.companySize) === null || _a === void 0 ? void 0 : _a.min;
                self.maxSize = (_b = response.companySize) === null || _b === void 0 ? void 0 : _b.max;
            }
            catch (e) {
                logger.warn("couldn't fetch user's company info");
            }
        }
    }),
});
export default Actions;
